import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { LuckyDrawService } from "../services/lucky-draw.service";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import Swal from "sweetalert2";
import { loadAppConfig } from "../../../configs/app-config";
import { Image } from "antd";

import TitleImg from "../../../assets/images/econnect-title.png";

type TUserOfLucky = {
  id: number;
  listUsers: {
    fullName: string;
    id: number;
  };
};

export const Draw: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { id } = useParams<{ id: string }>();
  const [statusLucky, setStatusLucky] = useState<boolean>(false);
  const [luckyName, setLuckyName] = useState<TUserOfLucky | null>(null);
  const [winner, setWinner] = useState<TUserOfLucky | null>(null);
  const [winnerList, setWinnerList] = useState<TUserOfLucky[]>([]);
  const [dataUserOfLucky, setUserOfLucky] = useState<TUserOfLucky[]>([]);
  const [nameList, setNameList] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading === true) loadData();
  }, [loading]);
  useEffect(() => {
    setStatus();
  }, []);

  const loadData = async () => {
    setWinner(null);
    const usersOfLucky = await LuckyDrawService(apiBaseUrl).findRandomLucky(id);
    const winners = await LuckyDrawService(apiBaseUrl).findWinnerById(id);
    setUserOfLucky(usersOfLucky);
    setWinnerList(winners);
    const names: string[] = [];
    usersOfLucky.map((item: TUserOfLucky) =>
      names.push(item.listUsers.fullName ? item.listUsers.fullName : "")
    );
    const statusStart = await LuckyDrawService(apiBaseUrl).findById(id);
    setNameList(names);
    setStatusLucky(statusStart.status);
    setLoading(false);
  };
  const setStatus = () => {
    const gameStartInternal = setInterval(async () => {
      const statusStart = await LuckyDrawService(apiBaseUrl).findById(id);
      setStatusLucky(statusStart.status);
      if (statusLucky === true) {
        const random =
          dataUserOfLucky[Math.floor(Math.random() * dataUserOfLucky.length)];
        setLuckyName(random);
      }
    }, 500);
    return () => {
      clearInterval(gameStartInternal);
    };
  };
  useEffect(() => {
    if (statusLucky === true) {
      console.log("spingggggggggggg");
      const randomInterval = setInterval(() => {
        if (dataUserOfLucky.length > 0) {
          const random =
            dataUserOfLucky[Math.floor(Math.random() * dataUserOfLucky.length)];
          setLuckyName(random);
        }
      }, 100);
      return () => {
        clearInterval(randomInterval);
      };
    } else {
      if (dataUserOfLucky.length > 0) {
        const random =
          dataUserOfLucky[Math.floor(Math.random() * dataUserOfLucky.length)];
        setLuckyName(random);
        setWinner(random);
      }
    }
  }, [statusLucky]);

  useEffect(() => {
    if (winner && winner?.listUsers.fullName) {
      console.log(winner);
      getWinner();
    }
  }, [winner]);

  async function getWinner() {
    if (winner) {
      const listUsersId = winner.listUsers.id;
      const luckyId = id;
      const userofluckyId = winner.id;
      if (luckyId) {
        LuckyDrawService(apiBaseUrl).createLuckeyWinner(
          listUsersId,
          luckyId,
          userofluckyId
        );
        Swal.fire({
          width: "60%",
          color: "#000",
          padding: "6em",
          html: `<p class=' text-5xl text-blue-700' >WINNER</p> <br/> <div class=' font-bold text-6xl'>${winner?.listUsers.fullName}</div>`,
          // title: `WINNER <br/>${winner?.listUsers.fullName}`,
          showConfirmButton: false,
          background: "#fff",
          backdrop: `  url("/images/backdrop.gif")  left top  repeat-x`,
          timer: 5000,
        }).then(() => {
          setLuckyName(null);
          setLoading(true);
        });
      }
    }
  }

  return (
    <div className="backdrop-image  h-screen ">
      <div className="flex w-full  items-center justify-center min-h-screen relative">
        <div className=" absolute w-full  top-[-20px] text-center  ">
          <Image src={TitleImg} width={500} preview={false} />
          {/* <div className="w-full  justify-center">
            <span className=" mb-4 text-7xl font-extrabold leading-none tracking-tight  text-transparent bg-clip-text bg-gradient-to-r from-amber-700 to-blue-800">
              ECONNECT
            </span>
            <div className="  mb-4 text-2xl font-extrabold leading-none tracking-tight   text-white">
              AI-DRIVEN
            </div>
          </div> */}
        </div>
        <div key={1} className="flex w-full  items-center justify-center">
          <div className="flex justify-center w-full font-mono">
            <div className="bg-[#fff] w-[50%] p-14 border-2 rounded-lg shadow-lg ">
              <div>
                <div className="text-center">
                  <div className="text-center text-6xl font-bold leading-[43.58px] text-black">
                    {nameList.length > 0 ? (
                      <div>
                        {luckyName?.listUsers.fullName
                          ? luckyName?.listUsers.fullName
                          : "READY !!!"}
                      </div>
                    ) : (
                      <>ไม่มีรายชื่อ</>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
